module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.b7cd9561.svg";